import type { FC } from "react"
import { useTranslation } from "react-i18next"
import { Chip } from "@mui/material"

const FORECAST_TAG_KEYS: Record<string, string> = {
  hours: "dates.FORECAST_TAG_HOURS",
  days: "dates.FORECAST_TAG_DAYS",
}

interface ForecastChipProps {
  forecastTime: { timeAmount: number; timeUnit: string }
}

/** Tags a date reference that reaches past now, e.g. "+6 h forecast". */
const ForecastChip: FC<ForecastChipProps> = ({ forecastTime }) => {
  const { t } = useTranslation()
  const key = FORECAST_TAG_KEYS[forecastTime.timeUnit]
  if (!key) return null

  return (
    <Chip
      label={t(key, { count: forecastTime.timeAmount })}
      size="small"
      variant="outlined"
      sx={{
        fontSize: "0.6875rem",
        height: 22,
        flexShrink: 0,
        // The date picker button's own text color, for the outline too.
        color: "text.secondary",
        borderColor: "text.secondary",
      }}
    />
  )
}

export default ForecastChip
